<template>
    <Breadcrumbs main="Apps" title="Interview Process" />
    <div class="container-fluid">
        <div class="email-wrap bookmark-wrap">
            <div class="row">
                <interviewProcess />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const interviewProcess = defineAsyncComponent(() => import("@/components/front-office/interview-process/index.vue"))
</script>